(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vic-animated-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-vic-hero-videos]').forEach((stage) => {
    const videos = Array.from(stage.querySelectorAll('video'));
    if (!videos.length) return;

    const firstVideo = videos[0];
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (videos.length === 1 || reducedMotion) {
      videos.slice(1).forEach((video) => video.remove());
      firstVideo.loop = true;
      firstVideo.classList.add('is-active');
      firstVideo.play().catch(() => {});
      return;
    }

    let activeIndex = 0;
    let locked = false;

    const resetInactive = () => {
      videos.forEach((video, index) => {
        if (index === activeIndex) return;
        video.pause();
        try {
          video.currentTime = 0;
        } catch (error) {}
      });
    };

    const showVideo = (nextIndex) => {
      if (locked || nextIndex === activeIndex) return;
      locked = true;

      const currentVideo = videos[activeIndex];
      const nextVideo = videos[nextIndex];

      if (nextVideo.readyState < 2) {
        nextVideo.load();
      }

      try {
        nextVideo.currentTime = 0;
      } catch (error) {}

      nextVideo.play().catch(() => {});
      nextVideo.classList.add('is-active');
      currentVideo.classList.remove('is-active');
      activeIndex = nextIndex;

      window.setTimeout(() => {
        resetInactive();
        locked = false;
      }, 1150);
    };

    videos.forEach((video, index) => {
      video.loop = false;
      video.muted = true;
      video.playsInline = true;

      video.addEventListener('timeupdate', () => {
        if (index !== activeIndex || locked || !video.duration) return;
        if (video.duration - video.currentTime <= 1.25) {
          showVideo((activeIndex + 1) % videos.length);
        }
      });

      video.addEventListener('ended', () => {
        if (index === activeIndex) {
          showVideo((activeIndex + 1) % videos.length);
        }
      });
    });

    firstVideo.classList.add('is-active');
    firstVideo.play().catch(() => {});
    resetInactive();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vic-collection-tiles"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const pickTiles = () => {
      const used = new Set();

      document.querySelectorAll('[data-vic-random-images]').forEach((media) => {
        const img = media.querySelector('img');
        const images = (media.dataset.vicRandomImages || '')
          .split('||')
          .map((item) => item.trim())
          .filter(Boolean);

        if (!img || images.length < 2) return;

        const shuffled = images
          .map((url) => ({ url, sort: Math.random() }))
          .sort((a, b) => a.sort - b.sort)
          .map((item) => item.url);
        const selected = shuffled.find((url) => !used.has(url)) || shuffled[0];

        if (!selected) return;
        used.add(selected);
        img.removeAttribute('srcset');
        img.src = selected;
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', pickTiles, { once: true });
    } else {
      pickTiles();
    }

    document.addEventListener('shopify:section:load', pickTiles);
  })();

  } catch(e) { console.error(e); }
})();
})();
